module.exports = __webpack_public_path__ + "static/media/member.a425f7c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/member.svg
// module id = 9
// module chunks = 0